// Angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Devextreme imports
import {
    DxBoxModule,
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxNumberBoxModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule
} from 'devextreme-angular';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// Module imports
import { SharedModule } from '../../../shared-module/shared.module';
import { ManagementCommonModule } from '../../../management-common/management-common.module';

// Component imports
import { ProjectTasksEditorComponent } from './project-tasks-editor.component';
import { ProjectTaskNotesEditorComponent } from '../project-task-notes-editor/project-task-notes-editor.component';
import { ProjectTaskViewerComponent } from '../project-task-viewer/project-task-viewer.component';

@NgModule({
    declarations: [ProjectTasksEditorComponent, ProjectTaskNotesEditorComponent, ProjectTaskViewerComponent],
    imports: [
        CommonModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        SharedModule,
        ManagementCommonModule,
        DxBoxModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxSelectBoxModule,
        DxToolbarModule,
        DxFormModule,
        DxNumberBoxModule,
        DxTextBoxModule,
        DxTextAreaModule,
        DxDateBoxModule,
        DxPopupModule,
        DxSwitchModule
    ],
    exports: [ProjectTasksEditorComponent, ProjectTaskNotesEditorComponent, ProjectTaskViewerComponent]
})
export class ProjectTaskEditorModule {}
